import React, { FC } from 'react';
import { LoadableData } from '../../../../utils';
import { LogEvent } from 'common/dist/types/orchestration/logs';
import { ApiError } from 'common/dist/types/responseBodies/errors';
import styles from './styles.module.scss';
import ReactLoading from 'react-loading';
import classNames from 'classnames';
import vars from '../../../../../scss/base/var.module.scss';

type Props = {
  logs?: LoadableData<LogEvent[], ApiError>;
};

const JobLogs: FC<Props> = ({ logs }) => {
  if (!logs) return null;

  const { loading, loaded, error, data } = logs;

  if (loading) {
    // Loading
    return (
      <div className={styles.jobLogs}>
        <ReactLoading type={'cylon'} color={vars.colorPrimary} />
      </div>
    );
  } else if (error) {
    // Error
    return <div className={styles.jobLogs}>{JSON.stringify(error)}</div>;
  } else if (loaded && (data || []).length === 0) {
    // Loaded but empty
    return (
      <div className={classNames(styles.jobLogs, styles.empty)}>
        <span>There are no logs for this job</span>
      </div>
    );
  } else {
    // Loaded and has data
    return (
      <div className={styles.jobLogs}>
        <table>
          {(data || []).map((logEvent) => (
            <tr className={styles.logEvent}>
              <td className={styles.lineNumber}>{logEvent.n}</td>
              <td className={styles.logMessage}>{logEvent.message}</td>
            </tr>
          ))}
        </table>
      </div>
    );
  }
};

export default JobLogs;
